import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { jobPostQueryOptions } from './useJobPost';

export const useBookmarkJobPost = (jobPostId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (bookmark: boolean) => {
      await fetchJson(`/job-posts/${jobPostId}/bookmark`, {
        method: bookmark ? 'POST' : 'DELETE',
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(jobPostQueryOptions(jobPostId));
      queryClient.invalidateQueries({ queryKey: QueryKeys.jobPosts.index.root });
    },
  });
};
